import mysql from "mysql2/promise";
if (process.env.NODE_ENV !== "production") {
  const dotenv = await import("dotenv");
  dotenv.config();
}
const pool = mysql.createPool({
  host: process.env.DB_HOST,
  user: process.env.DB_USER,
  password: process.env.DB_PASSWORD,
  database: process.env.DB_NAME,
  waitForConnections: true,
  connectionLimit: 10,
  // adjust based on your DB's limit
  queueLimit: 0
});
async function getUserByName(name) {
  const [results] = await pool.query("SELECT * FROM users where email = ? LIMIT 1", [name]);
  return results[0];
}
async function getMainAlertContent() {
  const [results] = await pool.query(`SELECT * FROM general WHERE id = 'main-alert-content' LIMIT 1`);
  if (results.length === 0 || !results[0]) {
    return {
      time: 0,
      blocks: []
    };
  }
  return JSON.parse(results[0].value);
}
async function getMainAlertVisibility() {
  const [results] = await pool.query(`SELECT * FROM general WHERE id = 'main-alert-visible' LIMIT 1`);
  if (results.length === 0) {
    return false;
  }
  return JSON.parse(results[0].value);
}
async function setMainAlertContent(content) {
  await pool.query(`UPDATE general SET value = ? WHERE id = 'main-alert-content'`, [JSON.stringify(content)]);
}
async function setMainAlertVisibility(visible) {
  await pool.query(`UPDATE general SET value = ? WHERE id = 'main-alert-visible'`, [JSON.stringify(visible)]);
}
export {
  setMainAlertVisibility as a,
  getMainAlertVisibility as b,
  getMainAlertContent as c,
  getUserByName as g,
  setMainAlertContent as s
};
